import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class MaxLoanDeleteService {

  constructor(private http: HttpClient) { }

  deleteMaxLoanOverride(
    baseUrl: string,
    jsonSettings: string,
    jsonData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Use the correct endpoint with action_code like in original AngularJS
    const url = `${baseUrl}/saveJsonObject?action_code=vms99b`;
    
    // Build checkLockedbj like in original AngularJS using rowData
    const checkLockedbj: any[] = [];
    
    if (jsonData && jsonData.length > 0 && jsonData[0]) {
      checkLockedbj.push({
        "leid": jsonData[0].LEID || rowData.LEID,
        "cdr_number": jsonData[0].CDR_NO || rowData.CDR_NO || rowData.MARS,
        "reporting_period": String(jsonData[0].REPORTING_PERIOD || rowData.REPORTING_PERIOD || ''),
        "combination_key": String(jsonData[0].COMBINATION_KEY || rowData.COMBINATION_KEY),
        "scenario_key": parseInt(filterParams.scenario || globalService?.globalParams?.scenario || '74')
      });
    }
    
    // Build payload structure exactly like in original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Add JSON data and settings
    params = _.extend({ jsonObj: JSON.stringify(jsonData) }, params);
    params = _.extend({ jsonSettings: jsonSettings }, params);
    
    // Add process name
    params.process_name = "deleteMaxloanOverrideAmt";
    
    // CRITICAL: Add checkLockedbj
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // CRITICAL: Add scenarioCode with fallback
    if (!params.scenarioCode) {
      params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || globalService?.globalParams?.scenarioCode || 'RAF';
    }
    
    // CRITICAL: Add is_issue_key_enabled
    if (!params.is_issue_key_enabled) {
      params.is_issue_key_enabled = 'N';
    }

    // Convert params to URLSearchParams for form-urlencoded format (like AngularJS)
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key]);
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }
}

